import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';

export interface Option {
  text: string;
  clickable?: boolean;
}

export interface SelectTabOption {
  index: number;
  item: Option;
}

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class TabComponent implements OnInit {

  @Input('options') options: Option[] = []; 
  @Input('indexSelected') indexSelected: number = 0;
  @Output('seletedTab') seletedTab: EventEmitter<SelectTabOption> = new EventEmitter<SelectTabOption>();

  constructor() { }

  ngOnInit() {
  }

  onSelect(item: Option, index: number) {
    this.seletedTab.emit({
      index: index,
      item: item
    });
  }

}

@Component({
  selector: 'app-pago-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class TabPagoComponent implements OnInit {

  @Input('options') options: Option[] = []; 
  @Input('indexSelected') indexSelected: number = 0;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/tab/tab.component.ts